import React from 'react';
import PropTypes from 'prop-types';
import { SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import { Navigation } from 'swiper';
import Icons from '../Icons';
import * as S from './styled';

const BUTTON_SELECTOR = 'custom_button';

const CustomPrevButton = ({ onClick, id }) => (
  <S.Prev onClick={onClick} id={id} data-testid={id}>
    <Icons.PrevArrow color="var(--swiper-edge-icon)" />
  </S.Prev>
);

const CustomNextButton = ({ id, onClick }) => (
  <S.Next onClick={onClick} id={id} data-testid={id}>
    <Icons.NextArrow color="var(--swiper-edge-icon)" />
  </S.Next>
);

const Swiper = ({ id = BUTTON_SELECTOR, componentsList }) => (
  <S.Container>
    <CustomPrevButton id={`${id}_prev`} />
    <S.Swiper
      navigation={{
        nextEl: `#${id}_next`,
        prevEl: `#${id}_prev`
      }}
      slidesPerView="auto"
      mousewheel
      modules={[Navigation]}>
      {componentsList.map((item, index) => (
        <SwiperSlide key={index}>{item}</SwiperSlide>
      ))}
    </S.Swiper>
    <CustomNextButton id={`${id}_next`} />
  </S.Container>
);
Swiper.propTypes = {
  componentsList: PropTypes.arrayOf(PropTypes.node).isRequired,
  id: PropTypes.string
};

export default Swiper;
